import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../utils/api';

/**
 * LandingPage - Public marketing homepage
 * Shows landing page immediately, then redirects if user is already logged in
 */
const LandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is already logged in (non-blocking)
    const checkAuth = async () => {
      try {
        await auth.getCurrentUser();
        // User is logged in, redirect to app
        navigate('/recipe-box', { replace: true });
      } catch {
        // Not logged in, stay on landing page (already showing)
      }
    };
    checkAuth();
  }, [navigate]);

  // Show landing page immediately - no loading state
  return (
    <iframe
      src="/landing-v2.html"
      title="Honey - Cooking Companion"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block'
      }}
    />
  );
};

export default LandingPage;
